import styled from "@mui/styled-engine";
import icon from "../assets/images/icons/icon-100x100.png";

interface CricketMarkProps {
  active: boolean;
}

export default function DartBoardIcon({ active = false }: CricketMarkProps) {
  return <StyledIcon src={icon} active={active} />;
}

interface StepIconProps {
  active?: boolean;
}

const StyledIcon = styled("img")<StepIconProps>(({ active = false }) => ({
  height: 24,
  width: 24,
  opacity: active ? 1 : 0.5,
}));
